import React, { useEffect, useRef } from 'react';
import styles from '../styles/settings.module.scss'
import classNames from "classnames";
import {useHistory} from 'react-router-dom'
import Globals from 'system/Globals'

const AccountBlock = ({ icon, heading, text, cta, link, background, target, orientation }) => {
  const history = useHistory();

  function onClickLink() {
    if (link && target) {
     
       if(Globals.instance().electron){
            if(window.api && window.api.send) {
                window.api.send("toApp", {"event":"external-link","link":Globals.instance().cmsEditLink});
                return;
            }
        }
       window.open(link, target ? target : "_self");
    } else {
      history.push('/account')
    }
  }

  useEffect(() => {
    // Any animation or side effects can be handled here
  }, []);

  return (
    <span className={classNames(styles.accountBlock, orientation ? styles[orientation] : '')} style={{backgroundColor: background}} target={target ? target : "_self"} rel="noreferrer">
      <div className={styles.accountBlockIcon}>{icon}</div>
      <div className={styles.accountBlockContent}>
        <h3>{heading}</h3>
        {text && <p>{text}</p>}
        {cta && <span onClick={onClickLink} className={styles.accountBlockBtn}>{cta}</span>}
      </div>
    </span> 
  );
};

export default AccountBlock;